import { render } from "./addCategory.vue?vue&type=template&id=4c2fab0a&scoped=true"
import script from "./addCategory.vue?vue&type=script&lang=js"
export * from "./addCategory.vue?vue&type=script&lang=js"

import "./addCategory.vue?vue&type=style&index=0&id=4c2fab0a&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2fab0a"]])

export default __exports__